<template>
	<div>
		<h1>Eligibility Criteria</h1>

		<i
			>Inclusion and exclusion criteria for participants. If applicable,
			eligibility criteria for study centres and individuals who will perform
			the interventions (eg, surgeons, psychotherapists).</i
		>

		<InputSelectMulti
			question="What age groups are eligible participants in?"
			:options="ageOptions"
			v-model="$tera.project.TrialWizard.ages"
			bookmark="age-group"
		/>

		<InputTextSingleLine
			question="What age bracket are eligible participants in?"
			placeholder="e.g. 18-25 years"
			v-model="$tera.project.TrialWizard.ageBracket"
			bookmark="age-bracket"
		/>

		<InputSelectMulti
			question="What sexes are eligible for inclusion?"
			:options="sexOptions"
			v-model="$tera.project.TrialWizard.sexes"
			bookmark="eligible-inclusion"
		/>

		<InputSelectMulti
			question="What conditions are eligible for study?"
			:options="conditionOptions"
			v-model="$tera.project.TrialWizard.conditions"
			bookmark="eligible-condition"
		/>

		<InputSelectMulti
			question="What severity of condition is eligible? (optional)"
			:options="severityOptions"
			v-model="$tera.project.TrialWizard.severity"
			bookmark="eligible-severity"
		/>

		<InputSelectMulti
			question="What other factors are eligible for inclusion?"
			:options="otherOptions"
			v-model="$tera.project.TrialWizard.others"
			bookmark="eligible-factors"
		/>

		<InputSelectMulti
			question="What other factors are excluded from the study?"
			:options="otherOptions"
			v-model="$tera.project.TrialWizard.othersExcluded"
			bookmark="eligible-excluded"
		/>

		<InputSelectMulti
			question="What measurements were performed on participants at baseline (start of study)?"
			:options="measurementOptions"
			v-model="$tera.project.TrialWizard.baselineMeasurements"
			bookmark="measurements"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import OutputEligibilityCriteria from "./OutputEligibilityCriteria.vue";

export default {
	data() {
		return {
			ageOptions: [
				{ label: "Infants" },
				{ label: "Children" },
				{ label: "Adolescents" },
				{ label: "Adults" },
				{ label: "Elderly" }
			],
			conditionOptions: [
				{ label: "Healthy" },
				{ label: "Diabetic" },
				{ label: "Demented" },
				{ label: "Immunocompromised" }
			],
			severityOptions: [
				{ label: "Mild" },
				{ label: "Moderate" },
				{ label: "Severe" }
			],
			measurementOptions: [
				{ label: "Blood glucose level" },
				{ label: "Blood pressure" },
				{ label: "Pulse" }
			],
			otherOptions: [
				{ label: "Pregnant" },
				{ label: "Smoking" },
				{ label: "Non-smoking" },
				{ label: "Obese" },
				{ label: "Overweight" },
				{ label: "Institutionalised" }
			],
			outputComponent: OutputEligibilityCriteria,
			sexOptions: [{ label: "Female" }, { label: "Male" }]
		};
	}
};
</script>
